<template>
  <aside class="menu">
    <div v-for="(menu, menu_index) in menus" :key="menu_index" class="box">
      <p class="menu-label">
        <span v-html="menu.name"></span>
      </p>

      <ul class="menu-list" v-if="menu.submenus !== undefined" v-for="(submenu, sm_index) in menu.submenus" :key="sm_index">
        <li v-if="submenu.submenus !== undefined && submenu.submenus.length != 0">
          <nuxt-link :to="`/${submenu.value}`"
            exact
            v-html="submenu.name"
            :class="[
              submenu.class,
            ]"
          ></nuxt-link>
          <ul>
            <li v-for="(sm1, sm1_index) in submenu.submenus" :key="sm1_index">
              <nuxt-link :to="`/${sm1.value}`"
                exact
                :class="[
                  { 'has-text-grey disabled': sm1.disabled },
                  sm1.class,
                ]" v-html="sm1.name"
              ></nuxt-link>
            </li>
          </ul>
        </li>
        <li v-else>
          <nuxt-link :to="`/${submenu.value}`"
            exact
            :class="[
            { 'has-text-grey disabled': submenu.disabled },
              submenu.class,
            ]"
            v-html="submenu.name"
          ></nuxt-link>
        </li>
      </ul>
    </div>
  </aside>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { GROUP } from '~/consts';

export default {
  data() {
    return {
      menus: [
        {
          name: 'GENERAL',
          submenus: [
            { value: 'panel', name: 'Dashboard' },
            { value: 'panel/groups', name: 'Grup Akademik' },
          ]
        },
      ]
    }
  },

  methods: {
    ...mapActions([
      'logout'
    ]),
  }
}
</script>
